export interface GalleryCategory {
  name: string
  tag: string
  caption: string
  image: string
  featured?: boolean
}

const IMAGES = {
  herbario:
    'https://cdn.magicpatterns.com/uploads/4S2sRMB4G9EuhZ2FSyLY1Y/cuadro_herbario.jpg',
  resina:
    'https://cdn.magicpatterns.com/uploads/jS7XoHU9udkvzvkX59EUtC/joyeria_en_resina.jpg',
  velas: 'https://cdn.magicpatterns.com/uploads/5oxanzMC28n1HE3mkg4qBj/velas.jpg',
  tarjetas:
    'https://cdn.magicpatterns.com/uploads/noAhsw1BJC73dzpFRpV461/tarejtas_de_regalo.jpg',
  marcapaginas:
    'https://cdn.magicpatterns.com/uploads/4tP5xiJCsJbWB1uhn7t5qG/marcapaginas.jpg',
  cuadros:
    'https://cdn.magicpatterns.com/uploads/fE2VgWMhtNXg5oj1eFgwXU/cuadros_botanicos.jpg',
}

export const galleryImages = IMAGES

export const galleryCategories: GalleryCategory[] = [
  {
    name: 'Cuadro herbario',
    tag: 'Composición botánica',
    caption: 'Especies etiquetadas a mano sobre lino, en marco de latón',
    image: IMAGES.herbario,
    featured: true,
  },
  {
    name: 'Cuadros botánicos',
    tag: 'Cuadro floral',
    caption: 'Composición circular con pétalos y margaritas',
    image: IMAGES.cuadros,
  },
  {
    name: 'Marcapáginas',
    tag: 'Idea para regalo',
    caption: 'Margarita, helecho y flores azules con borla de hilo',
    image: IMAGES.marcapaginas,
  },
  {
    name: 'Tarjetas florales',
    tag: 'Tarjeta floral',
    caption: 'Papel de algodón, kraft y moño de cinta',
    image: IMAGES.tarjetas,
  },
  {
    name: 'Velas decoradas',
    tag: 'Proyecto decorativo',
    caption: 'Pétalos y helechos fijados en la cera',
    image: IMAGES.velas,
  },
  {
    name: 'Dijes y accesorios',
    tag: 'Pieza para vender',
    caption: 'Flores prensadas encapsuladas con detalle en dorado',
    image: IMAGES.resina,
  },
]

export interface GalleryPhoto {
  alt: string
  tag: string
  image: string
}

export const galleryCarousel: GalleryPhoto[] = [
  {
    alt: 'Cuadro herbario con especies etiquetadas a mano en marco de latón',
    tag: 'Composición botánica',
    image: IMAGES.herbario,
  },
  {
    alt: 'Cuadro botánico con pétalos rosas y margaritas en marco de madera',
    tag: 'Cuadro floral',
    image: IMAGES.cuadros,
  },
  {
    alt: 'Marcapáginas con margarita, helecho y flores azules',
    tag: 'Idea para regalo',
    image: IMAGES.marcapaginas,
  },
  {
    alt: 'Tarjetas de regalo con flores prensadas y sobres kraft',
    tag: 'Tarjeta floral',
    image: IMAGES.tarjetas,
  },
  {
    alt: 'Velas decoradas con flores y helechos prensados',
    tag: 'Proyecto decorativo',
    image: IMAGES.velas,
  },
  {
    alt: 'Dijes de flores prensadas con cadena dorada',
    tag: 'Pieza para vender',
    image: IMAGES.resina,
  },
]
